import { render, staticRenderFns } from "./Popconfirm.vue?vue&type=template&id=425682a2&"
import script from "./Popconfirm.vue?vue&type=script&lang=js&"
export * from "./Popconfirm.vue?vue&type=script&lang=js&"
import style0 from "./popconfirm.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports